import PropTypes from "prop-types";

export const _SubmitButton = {
  action: PropTypes.func,
  className: PropTypes.string,
  Icon: PropTypes.elementType,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  isDisabled: PropTypes.bool,
  isSubmit: PropTypes.bool,
  name: PropTypes.string,
  onlyIcon: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export const SubmitButtonPropTypes = _SubmitButton;
